/** Move item no array (reordenação manual com setas). */
export function moverItemLista(lista, index, delta) {
  const next = index + delta;
  if (next < 0 || next >= lista.length) return lista;
  const copia = [...lista];
  const [item] = copia.splice(index, 1);
  copia.splice(next, 0, item);
  return copia;
}

/** Ordena cópia da lista por chave string (locale pt-BR). */
export function ordenarListaPor(lista, chave, direcao = 'asc') {
  const fator = direcao === 'desc' ? -1 : 1;
  return [...lista].sort((a, b) => {
    const va = String(a[chave] ?? '').toLocaleLowerCase('pt-BR');
    const vb = String(b[chave] ?? '').toLocaleLowerCase('pt-BR');
    return va.localeCompare(vb, 'pt-BR') * fator;
  });
}
